// @flow
import React from 'react';

import {
    Container,
    Image
} from '../react';

import { checkIfReactNative } from './checkOS';

const styles = {
    loadingContainer: props => {
        if (!props) {
            return {
                width: '100%',
                alignSelf: 'center',
                display: 'flex',
                justifyContent: 'center'
            };
        }

        return {
            ...props
        };
    },
    loadingImage: props => {
        if (!props) {
            return { width: checkIfReactNative() ? '100%' : '50px'
            };
        }

        return {
            ...props
        };
    }
};

type Props = {

    /**
     * Style object for container.
     */
    containerStyle: Object,

    /**
     * Style object for Image.
     */
    imageStyle: Object,

    /**
     * Src of the component.
     */
    src: ?String


}

/**
 * Loding indicator.
 *
 * @param {Object} props - Props for a functional Component.
 * @returns {any}
 */
export default function LoadingComponent(props: Props) {
    return (
        <>
            <Container
                style = { styles.loadingContainer(props.containerStyle) }>
                <Image
                    className = 'loading-indicator'
                    src = { props.src }
                    style = { styles.loadingImage(props.imageStyle) } />
            </Container>
        </>
    );
}
